export const userNicknames = [
  'Diabeli',
  'Magma Magnesium',
  'Walter',
  'Raptors',
  'Warriors',
  'Billy',
  'Wakanda',
  'Overload',
  'Usiu',
  'Jazzy Pants',
  'Tendrils_of_Power',
  'Rubix Cube',
  'Fast Fingers',
  'Anger',
  'Destructa X',
  'Valley',
  'Princes of Jakku',
  'Caprice and Ice',
  'Oxidised',
  'Catwoman',
  'Batwoman',
  'Bruiser',
  'Bullwhip',
  'DeliriousDeadmine',
  'Delusional',
  'Elemental Alchemy',
  'Empress Sansa',
  'Ego Monster',
  'Dutch Heritage',
  'Red Force Army',
  'Erudite',
  'Spider Fingers',
  'Nerdy Nan',
  'Nectar of Sunshine',
  'Bee Basic',
  'Winter Child',
  'Sick-o-pants',
  'Fleabag',
  'Doge Dog',
  'Pinky Boy',
  'Dumpster',
  'Al_qualified',
  'Dumble Damn',
  'Traumatic Acid',
  'JollyDolly',
  'Dexter Pups',
  'WINchester',
  'Mad Aurora',
  'Candy Corn',
  'Psychotic',
  'Misogynistic Gamer',
  'MoonPie',
  'Munchkins',
  'Gobstopped',
  'Damsel In Dungeons',
  'RattleSnake',
  'Skinner',
  'Dynamite',
  'Harry Dotter',
  'Astro Ashe',
  'Airport Hobo',
  'Armadillo',
  'Gran Turismo',
  'Eerie Mizzen',
  'Devil Blade',
  'Parrot',
  'Pirate',
  'Mario RPG',
  'Decades',
  'Bouncing',
  'Flea',
  'Cat',
  'Diamond Gamer',
  'Metal Gear Solid',
  'Meta Knight',
  'Cherry',
  'Mario Brothers',
  'Ori Super',
  'Nidoking',
  'Link Man',
  'Evil Genius',
  'Wario',
  'Valgazza',
  'Madden NFL',
  'Super Smash Bros',
  'Feta',
  'Alice',
  'Alex Jones',
  'Waluigi',
  'Diablo',
  'Dweezil',
  'Zelda',
  'Weim',
  'Junk',
  'Thermajin',
  'Terraria',
  'Advanced Gaming',
  'Uncharted',
  'Donkey Kong',
  'Dragon',
  'Fallout',
  'Raging Ogres',
  'Powerdrive',
  'Candy Cane',
  'Umara',
  'Lazir',
  'Lara Croft',
  'Nihnum',
  'Trax',
  'Rose',
  'Fizz',
  'Finger of Death',
  'Criss Cross',
  'Bug Blitz',
  'Ballistic',
  'Uprising',
  'Aero',
  'Electric Saturn',
  'Fire Fish',
  'Mortar',
  'Steelshot',
  'Vein',
  'Socket',
  'Arsenal',
  'Skinner',
  'Fast Draw',
  'Khan',
];
